class Ipfs {
  constructor({ _id, id, url, type, project_id }) {
    this.id = id || _id;
    this.url = url;
    this.type = type;
    this.project_id = project_id;
  }
}
export default Ipfs;
